import { Drawer } from "antd";
import { MenuFolderDto } from "../../generated/dashboard-client";
import "./MoveToFolderModal.scss";
import { FolderThumb } from "../pages/Designs";
import { MoveToFolderMenuContent } from "./MoveToFolderMenuContent";

export interface MoveToFolderDrawerProps {
  isVisible: boolean;
  ids: string[];
  folders: MenuFolderDto[];
  activeFolder: MenuFolderDto | null;
  onBack: () => void;
  onCloseMovedToFolder: (save: boolean, folder?: MenuFolderDto) => void;
  onCloseMovedToSavedDesigns: (designIds: string[]) => void;
  onCloseMovedFolderToFolder: (childFolderId: number, parentFolderId: string) => void;
  onCreateNewFolder: () => void;
  onCreateFolderModalClose: (ids: string[], folderToMove?: MenuFolderDto | null, folder?: MenuFolderDto) => void;
  folderToMove: MenuFolderDto | null;
  folderThumbs: FolderThumb[];
  folderNameExists: (folder: MenuFolderDto | null, name: string) => boolean | undefined;
}

export function MoveToFolderDrawer({
  isVisible,
  ids,
  folders,
  activeFolder,
  onBack,
  onCloseMovedToFolder,
  onCloseMovedToSavedDesigns,
  onCloseMovedFolderToFolder,
  onCreateNewFolder,
  onCreateFolderModalClose,
  folderToMove,
  folderThumbs,
  folderNameExists
}: MoveToFolderDrawerProps) {
  return (
    <Drawer
      className={"mobile-bottom-menu add-design-to-folder"}
      onClose={() => onCloseMovedToFolder(false)}
      placement={"bottom"}
      visible={isVisible}
      closable={false}
      height={"600px"}
      zIndex={2000}
    >
      <MoveToFolderMenuContent
        ids={ids}
        folders={folders}
        activeFolder={activeFolder}
        onCloseMovedToFolder={onCloseMovedToFolder}
        onCloseMovedToSavedDesigns={onCloseMovedToSavedDesigns}
        onCloseMovedFolderToFolder={onCloseMovedFolderToFolder}
        folderToMove={folderToMove}
        folderThumbs={folderThumbs}
        folderNameExists={folderNameExists}
        onCreateFolderModalClose={onCreateFolderModalClose}
        isMobile={true}
        onBack={onBack}
      />
    </Drawer>
  );
}
